import Column from '@app/components/layout/Column'
import { TextInput } from '@app/components/core/input/text/TextInput'
import { useTranslations } from '@i18n/useLanguage'
import { useCallback, useEffect, useState } from 'react'
import { useClient } from '@based/sdk/react'
import { useToast } from '@app/util/hooks/useToast'
import { FieldEditActions } from '../shared/FieldEditActions'
import { useEditContainerClose } from '../shared/useEditContainerClose'

export type ProjectSizeFieldEditProps = {
  initiativeId: number
  projectSize: string
}

export const ProjectSizeFieldEdit = ({
  initiativeId,
  projectSize,
}: ProjectSizeFieldEditProps) => {
  const close = useEditContainerClose()
  if (!close) {
    throw new Error('ProjectSizeFieldEdit requires an EditContainer ancestor')
  }
  const client = useClient()
  const { showFailToast, showSuccessToast } = useToast()
  const t = useTranslations().app.common
  const creationTranslations =
    useTranslations().app.dashboard.initiative.creation

  const [text, setText] = useState(projectSize)

  useEffect(() => {
    setText(projectSize)
  }, [projectSize])

  const save = useCallback(() => {
    void client
      .call('edit-initiative', {
        id: initiativeId,
        value: {
          projectSize: text,
        },
      })
      .then((success) => {
        if (success) {
          showSuccessToast(t.toastSuccess)
          close()
        } else {
          showFailToast()
        }
      })
      .catch(() => showFailToast())
  }, [
    client,
    initiativeId,
    text,
    close,
    showFailToast,
    showSuccessToast,
    t.toastSuccess,
  ])

  return (
    <Column gap="1rem" alignItems="stretch">
      <TextInput
        label={creationTranslations.projectSize}
        text={text}
        setText={setText}
      />
      <FieldEditActions onCancel={close} onSave={save} />
    </Column>
  )
}
